<svg class="m-icon"
     @click="onClick"
     @keydown="onKeydown"
     :aria-hidden="!hasSvgTitle"
     :width="size"
     :height="size"
     @mouseover="onMouseOver"
     @mouseleave="onMouseLeave">
    <title v-if="hasSvgTitle">{{svgTitle}}</title>
    <use :xlink:href="spriteId"
         aria-hidden="true"
         :class="showNameAsClassInHtml"></use>
</svg>
